import {GET_ACCESSIBLE_STUDENT_MODULES, RESET_ACCESSIBLE_MODULES_DATA} from './accessible-action-types'
import {RESET_ACCESSIBLE_MODULES, SET_ACCESSIBLE_MODULES, SET_FILTERED_MODULES} from './accessible-mutation-types'
import * as axios from 'axios'

const state = {
  modules: [],
  modulesFiltered: [],
  filters: [],
  defaultFilter: undefined,
  loading: true
}

const mutations = {
  [SET_ACCESSIBLE_MODULES] (state, modulesPayload) {
    let yearFilters = []
    state.modules = modulesPayload.map((item) => {
      let nextYear = item.academicYear + 1
      let academicYear = item.academicYear + '/' + (nextYear + '').substring(2)
      yearFilters.push(item.academicYear)
      return {
        moduleCode: item.module.moduleIdentifier,
        moduleName: item.module.moduleDescription,
        academicYear: academicYear,
        credits: item.module.credits,
        attendance: item.attendanceSummary.percentage + '%',
        assessment: item.moduleGrade ? item.moduleGrade : (item.assessments.length === 0 ? 'N/A' : (item.assessments.length === 1 ? item.assessments.length + ' Assessment' : item.assessments.length + ' Assessments'))
      }
    })
    if (yearFilters.length > 0) {
      state.filters = Array.from(new Set(yearFilters)).sort().reverse()
      let currentYear = state.filters[0]
      let nextYear = currentYear + 1
      let currentAcademicYear = currentYear + '/' + (nextYear + '').substring(2)
      state.defaultFilter = currentAcademicYear
      state.modulesFiltered = state.modules.filter(el => el.academicYear === currentAcademicYear)
    }
    state.loading = false
  },
  [SET_FILTERED_MODULES] (state, filter) {
    state.modulesFiltered = state.modules.filter(el => el.academicYear === filter)
  },
  [RESET_ACCESSIBLE_MODULES] (state) {
    state.modules = []
    state.modulesFiltered = []
    state.filters = []
    state.defaultFilter = undefined
    state.loading = true
  }
}

const actions = {
  [GET_ACCESSIBLE_STUDENT_MODULES] ({rootState, commit}, studentId) {
    const actionData = { action: GET_ACCESSIBLE_STUDENT_MODULES, data: studentId }
    axios({
      url: `${rootState.config.baseUrl}:${rootState.config.port}/core/student/${studentId}/modules`,
      method: 'get',
      headers: {
        'Authorization': rootState.profile.loginToken
      },
      actionData
    }).then((res) => {
      commit(SET_ACCESSIBLE_MODULES, res.data)
    }).catch((err) => {
      console.error(err)
    })
  },
  [RESET_ACCESSIBLE_MODULES_DATA] ({commit}) {
    commit(RESET_ACCESSIBLE_MODULES)
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/accessibility/accessibleStudentModule.js